import React from 'react'
import Tooltip from '../../Components/common/Tooltip';

const TaskSourceIcon = ({task}) => {
  return (
    task.taskSource ? (
        <Tooltip className='overDue-tooltip tooltip-mt0' text={task.taskSource.charAt(0).toUpperCase() + task.taskSource.slice(1)} wrapperClassName="relative"> 
          <a className="hovr-btn tooltip-hover">
            <span
              key={"task-" + task.id}
              className="flex items-center justify-center gap-[2px]"
            >
              <img width={15} src={`/images/${task.taskSource}.png`} alt={task.taskSource} />
            </span>
          </a>
        </Tooltip>
    ) : null
  )
}

export default TaskSourceIcon;